import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { State } from 'store/types';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { AB_AGG_FOOTER_SSR } from 'shared/constants/experiments';

const CATEGORY_PATHNAME = '/c/';

export function useAggregatorFooter() {
  const location = useLocation();

  const isAggregatorFooterEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, AB_AGG_FOOTER_SSR, 'A')
  );

  const shouldSkipFooterGlobally =
    isAggregatorFooterEnabled && location.pathname.includes(CATEGORY_PATHNAME);

  return {
    isAggregatorFooterEnabled,
    shouldSkipFooterGlobally,
  };
}

export const isAggregatorFooterEnabled = (state: State) =>
  getEligibleForVariant(state, AB_AGG_FOOTER_SSR, 'A');
